import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/app/routes';
import { useAdminDetail } from '../api';
import { AdminSummaryCard } from '../components/AdminSummaryCard';
import { ActivityLogSection } from '../components/ActivityLogSection';

export function AdminDetailPage() {
  const { userId = '' } = useParams();
  const navigate = useNavigate();
  const adminId = Number(userId);
  const isValidId = userId !== '' && Number.isFinite(adminId);

  const query = useAdminDetail(adminId);
  const admin = query.data;

  return (
    <div className="mx-auto w-full max-w-3xl space-y-6 p-6">
      <nav className="text-sm text-muted-foreground">
        <button className="hover:text-foreground" onClick={() => void navigate(ROUTES.admins)}>
          Admin List
        </button>
        <span className="mx-2">/</span>
        <span className="text-foreground">Detail</span>
      </nav>

      {!isValidId ? (
        <p className="text-sm text-muted-foreground">Admin not found.</p>
      ) : query.isLoading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      ) : query.isError ? (
        <div className="space-y-3 py-8 text-center">
          <p className="text-sm text-destructive">Failed to load admin account.</p>
          <Button variant="outline" onClick={() => void query.refetch()}>
            Retry
          </Button>
        </div>
      ) : !admin ? (
        <p className="text-sm text-muted-foreground">Admin not found.</p>
      ) : (
        <>
          <AdminSummaryCard admin={admin} />
          <ActivityLogSection adminId={adminId} />
        </>
      )}
    </div>
  );
}
